module.exports = __webpack_public_path__ + "static/media/Montserrat-Bold.a361f0cc.eot";